import { render, staticRenderFns } from "./TopTracks.vue?vue&type=template&id=ab1c084e&scoped=true&"
import script from "./TopTracks.vue?vue&type=script&lang=js&"
export * from "./TopTracks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1c084e",
  null
  
)

export default component.exports